import { apiRequest, ApiError } from '@/lib/api/client';
import { getAuthToken } from '@/lib/api/token-store';

function createAuthHeaders(token, headers = {}) {
  const normalizedToken = String(token || getAuthToken() || '').trim();
  if (!normalizedToken) {
    throw new ApiError('authorization token is required', 401);
  }
  return {
    Authorization: `Bearer ${normalizedToken}`,
    ...headers,
  };
}

export async function fetchTenants({ token, q } = {}) {
  const query = new URLSearchParams();
  const normalizedQuery = String(q || '').trim();
  if (normalizedQuery) {
    query.set('q', normalizedQuery);
  }

  const path = query.toString() ? `/api/tenants/tenants?${query.toString()}` : '/api/tenants/tenants';
  const payload = await apiRequest(path, {
    method: 'GET',
    headers: createAuthHeaders(token),
  });

  return {
    items: Array.isArray(payload?.items) ? payload.items : [],
    count: Number(payload?.count) || 0,
    raw: payload,
  };
}
